import React from "react";

import {cn} from "@isudio/utils";
import {type IAssetSort, AssetSorts} from "@isudio/data";
import {FilterDropdown, SortDropdown} from "./";

interface DropdownsProps {
  className?: string;
  sorts?: IAssetSort[];
  onSortChange?: (filter: IAssetSort) => void;
  onFilterChange?: (payload: any) => void;
  selectedAssetType?: string | null;
}

const Dropdowns = React.forwardRef<Element, DropdownsProps>(
  ({
    className = "header-dropdowns",
    sorts = AssetSorts,
    onSortChange,
    onFilterChange,
    selectedAssetType,
  }
) => {
    return (
      <div
        className={cn(`${className}`, "h-8 flex justify-center align-center gap-2")}
      >
        <SortDropdown
          sorts={sorts}
          onChange={onSortChange}
        />

        <FilterDropdown
          selectedAssetType={selectedAssetType}
          onChange={onFilterChange}
        />
      </div>
    )
  }
);

Dropdowns.displayName = "Dropdowns"
export {Dropdowns}